import { quotationBusiness } from "api/bussiness/quotation/quotation-bussiness";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import type {
  PaginationSearchRequest,
  PaginationSearchResult,
} from "share-components/mui-wrap/auto-complete/x-auto-complete-with-pagination";

export const searchQuotationNumberOptions = async (keyword: string) => {
  const res = await quotationBusiness.searchQuotations(keyword);
  return mapToDistinctOptionItems(
    res.items?.filter((x) => x.number),
    (x) => x.number,
  );
};

export const searchQuotationNumberOptionsWithPagination = async (
  keyword: string,
  request: PaginationSearchRequest,
): Promise<PaginationSearchResult> => {
  const res = await quotationBusiness.getLists({
    filter: keyword,
    maxResultCount: request.pageSize,
    skipCount: request.pageIndex * request.pageSize,
    sorting: "",
  });

  return {
    items: mapToDistinctOptionItems(
      res.items?.filter((x) => x.number),
      (x) => x.number,
    ),
    totalCount: res.totalCount,
  };
};
